import { render, staticRenderFns } from "./configurationFive.vue?vue&type=template&id=c96a8b4a&scoped=true&"
import script from "./configurationFive.vue?vue&type=script&lang=js&"
export * from "./configurationFive.vue?vue&type=script&lang=js&"
import style0 from "./configurationFive.vue?vue&type=style&index=0&id=c96a8b4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96a8b4a",
  null
  
)

export default component.exports